const GalleryImages = [
  {
    src: '/gallery/event1.jpg',
    mobileSrc: 'gallery/mobile/event1.jpg',
    title: 'Flames 2.0',
    id: 'pic7',
  },
  {
    src: '/gallery/event2.jpg',
    mobileSrc: 'gallery/mobile/event2.jpg',
    title: 'Flames 2.0',
    id: 'pic8',
  },
  {
    src: '/gallery/event3.jpg',
    mobileSrc: 'gallery/mobile/event3.jpg',
    title: 'Flames 2.0',
    id: 'pic9',
  },
  {
    src: '/gallery/event4.jpg',
    mobileSrc: 'gallery/mobile/event4.jpg',
    title: 'Flames 2.0',
    id: 'pic10',
  },
  {
    src: '/gallery/event5.jpg',
    mobileSrc: 'gallery/mobile/event5.jpg',
    title: 'Flames 2.0',
    id: 'pic11',
  },
  {
    src: '/gallery/event6.jpg',
    mobileSrc: 'gallery/mobile/event6.jpg',
    title: 'Flames 2.0',
    id: 'pic12',
  },
  {
    src: '/gallery/event7.jpg',
    mobileSrc: 'gallery/mobile/event7.jpg',
    title: 'Flames 2.0',
    id: 'pic1',
  },
  {
    src: '/gallery/event8.jpg',
    mobileSrc: 'gallery/mobile/event8.jpg',
    title: 'Flames 2.0',
    id: 'pic2',
  },
];

export default GalleryImages;
